import styled from 'styled-components';

import RootButton from 'components/Button';

const Button = styled(RootButton)`
  margin: 50px 0 0;
`;

export default Button;
